import FeatureController from '../FeatureController';

export default class FeedbackController extends FeatureController{

    constructor (panel, $state) {
        super(panel, $state);
        this.feedback = {};
        this.referrer = '';// user history
        const self = this;
        this.panel.get('/v1/feedback', (response) => {
            if (self.panel.okay(response)) {
                self.types = response.types;
                self.feedback.type = response.types[0];
            }
        });
    }

    send_feedback () {
        this.error = '';

        if(!this.feedback){
            return this.panel.alert('Please fill in the feedback form!');
        }

        if(!this.feedback.type){
            return this.error = 'Please select a feedback type';
        }

        if(!this.feedback.title){
            return this.error = 'Please add a descriptive title';
        }

        if(!this.feedback.summary){
            return this.error = 'Please add a detailed summary for your feedback';
        }

        this.feedback.referrer = this.referrer;

        const self = this;

        this.panel.post('/v1/feedback', this.feedback, (response) => {
            if(self.panel.okay(response)){
                self.panel.alert("Thanks for your feedback. Submission successful. <i class='fa fa-check' style='color:#0ef444;font-size:24px;'></i>");
                this.feedback = {};
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/features/feedback/FeedbackController.js